import { render } from "./CageInfosModal.vue?vue&type=template&id=08c136f2&scoped=true&ts=true&lang=pug"
import script from "./CageInfosModal.vue?vue&type=script&lang=ts"
export * from "./CageInfosModal.vue?vue&type=script&lang=ts"

import "./CageInfosModal.vue?vue&type=style&index=0&id=08c136f2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c136f2"]])

export default __exports__